import(/* webpackMode: "eager" */ "/home/runner/work/waitlistly/waitlistly/src/app/(marketing)/privacy/page.tsx");
